import * as Yup from 'yup'

export const salaryItemSchema = Yup.object({
  description: Yup.string().required().max(255).default(''),
  amount: Yup.number().required().default(0),
})

export const useSalaryItemSchema = () => salaryItemSchema

export type SalaryItemFormValues = Yup.InferType<typeof salaryItemSchema>
